






import { PageConfig } from '@/store/modules/PageConfigs'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class FileViewerImage extends Vue {
  @Prop() src!: string
  @Prop() pageConfig!: PageConfig
}
